
import ModuleBase, { ViewLayer, moduleInit, bindButtonClickEvent } from "../../../../framework/core/mvvm/module_base";
import bindingCellphone_view from './bindingCellphone_view';
import ModuleManager from '../../../../framework/core/module_manager';
import Utility from "../../../../utility/utility";
import ModelData, { IUserData } from "../../../public/model_data";
import AppData from "../../../public/const/app_data";
import Hall from '../hall/hall';
import EventManager from "../../../../manager/event_manager";
import invitationCountdownManager from '../../../../manager/invitationCountdown_manager';
import LanguageManager from "../../../../manager/language_manager";
import LoaclStorage from "../../../../manager/local_storage";


const { ccclass, property } = cc._decorator;

@ccclass
@moduleInit("bindingCellphone")
export default class bindingCellphone extends ModuleBase<bindingCellphone_view, null> {

    loginScene = false;

    invitation: string = "";
    haveMobile: boolean = false;
    mobileNumber: string = "";
    areaCode: string = "";
    areaCodeArray:string[] = ["+60","+61","+62","+63","+64","+65","+66","+81","+82","+84","+850","+852","+853","+855","+856","+86","+880","+886","+95","+91","+92"]
    reg: RegExp = new RegExp("0");
    
    constructor() {
        super();
        this.layer = ViewLayer.Mid;
        this.windowPrefabResPath = "package/hall/module/bindingCellphone/bindingCellphone";
        this.viewType = bindingCellphone_view;
        this.modelType = null;
        this.needAnim = true
        this.needViewMask = true
        this.clickAnywhereClose = false;
    }
    
    protected onButtonClickName(name: string) {
        let self = this;
        switch (name) {
            case "closeBtn":
                Utility.playButtonSound()
                this.hide()
                cc.log("响应-----：", name);
                break;
            default:
                break;
        }
    }
    @bindButtonClickEvent("btnCancel")
    onButtonCancel() {
        if (!Utility.btnClickValid(1000)) {
            return
        }
        this.hide()
    }
    // @bindButtonClickEvent("openBinding")
    // onButtonOpenBinding() {
    //     let self = this;
    //     self.view.openBindingCellPhone(true);
    // }
    @bindButtonClickEvent("Invitation")
    onButtonGetInvitation() {
        let self = this;
        if (!Utility.btnClickValid(1000)) {
            return
        }
        // cc.log("&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&getInvitation")
        if (self.view.mobilePhoneEditorBox.string.length > 5) {
            this.getInvitation(self.view.mobilePhoneEditorBox.string);
        }
        else {
            ModuleManager.instance.toastKey("public_inputCorrentCellPhone");
        }
    }
    @bindButtonClickEvent("binding")
    onButtonBinding() {
        let self = this;
    
        
        if (!Utility.btnClickValid(1000)) {
            return
        }
        if (self.view.mobilePhoneEditorBox.string.length > 5) {
            this.binding(self.view.mobilePhoneEditorBox.string);
        }
        else {
            ModuleManager.instance.toastKey("public_inputCorrentCellPhone");
        }
    }
    @bindButtonClickEvent("closeBinding")
    onButtonCloseBinding() {
        if (!Utility.btnClickValid()) {
            return
        }
        Utility.playButtonSound()
        this.hide()
    }
    // @bindButtonClickEvent("cancelBinding")
    // onButtonCancelBinding() {
    //     let self = this;
    //     self.view.bindingNode.active = false;
    // }
    onInit(intentData: any) {
        this.setAreaCode();
        this.eventBind("refresh_AreaCode", (data) => {
            this.refreshAreaCode(data);
        })

    }

    onShow(intentData : any) {
        
        let self = this;
        this.loginScene = intentData.loginBinding;
        //var count = invitationCountdownManager.instance.getCountdown();
        let lastcurTime = LoaclStorage.getNumber("BIND_CODE_TIME")
        let curTime = Date.parse(new Date().toString())
        let count = (Number(lastcurTime) - Number(curTime)) * 0.001 + 60
        if (count > 0) {
            self.view.onClickInvitation(count);
        }
        else {
            self.view.setInvation(false);
        }
        self.view.invitationBtn.active = true;
        let dataStr = LoaclStorage.getString("SET_BANK_DATA")
        if (dataStr != null){
            let data = JSON.parse(dataStr)
            self.view.mobilePhoneEditorBox.string = data.PhoneNumber
            this.refreshAreaCode(data.PhoneHead)
        }
        if (this.areaCode != ""){
            self.view.defaultSet(this.areaCode);
        }

        self.view.updateStyle(intentData.loginBinding? 1 : 2);
    }


    setAreaCode() {
        switch (AppData.language) {
            case "th":
                this.areaCode = "+66";
                break;
            case "ch":
                this.areaCode = "+86";
                break;
            // case "en":
            //     this.areaCode = "+001";
            //     break;
        }
    }
    refreshAreaCode(str: string) {
        cc.log("刷新区域号:", str);
        if (str.length <= 0) { return }
        this.areaCode = str;
    }
    binding(mobilePhoneNumber: string) {
        let self = this
        var str = "";
        if (mobilePhoneNumber.startsWith('0')) {
            str = mobilePhoneNumber.slice(1, mobilePhoneNumber.length);
        }
        else {
            str = mobilePhoneNumber
        }
        if(!this.checkAreaCode(this.areaCode))
        {
            ModuleManager.instance.toastKey("รหัสพื้นที่ไม่ถูกต้อง");
            return;
        }

        if (!this.view.invitationEditorBox.string) {
            return;
        }
        

        if (this.loginScene) {
            
            this.eventDispatch("event_binding_phone_num",this.mobileNumber,this.view.invitationEditorBox.string);
            this.hide();
            return;
        }

        str = this.areaCode + "-" + str;
        this.mobileNumber = str;
        let requestData: IHttpRequestData;
       
        requestData = {
            baseUrl: "user/bindMobile?",
            params: {
                mobile: this.mobileNumber,
                verifyCode: this.view.invitationEditorBox.string
            }
        }
        
        
        cc.log("requestData:", requestData);
        this.apiHttpGet(requestData, (respone) => {
            cc.log("绑定结果的返回:", respone.data);
            self.eventDispatch("bind_cellphone_success")
            invitationCountdownManager.instance.resetTime();
            self.getSelfUserData(null, true);
            LoaclStorage.setNumber("BIND_CODE_TIME", Date.parse(new Date().toString()) - 6000)
            ModuleManager.instance.destroyModule("bindingCellphone");
            ModuleManager.instance.toastKey("Bind_bindCellphoneSuccess");
            
        })
    }
    //获取验证码
    getInvitation(mobilePhoneNumber: string) {
        cc.log('mobilePhoneNumber:', mobilePhoneNumber);
        let self = this
        var str = "";
        if (mobilePhoneNumber.startsWith('0')) {
            str = mobilePhoneNumber.slice(1, mobilePhoneNumber.length);
        }
        else {
            str = mobilePhoneNumber
        }
        if(!this.checkAreaCode(this.areaCode))
        {
            ModuleManager.instance.toastKey(LanguageManager.t("BindCellPhone_areaCodeError"));
            return;
        }
        str = this.areaCode + "-" + str;
        this.mobileNumber = str;
        let requestData: IHttpRequestData = {
            baseUrl: this.loginScene ? AppData.apiHttpUrl + "sendVerifyCodeUnSafe?" : "commons/sendBindVerifyCode?",
            params: {
                mobile: this.mobileNumber,
            },
            isApiRequest : !this.loginScene
        }
        cc.log("requestData:", requestData);
        this.apiHttpGet(requestData, (respone) => {
            cc.log('手机验证码返回结果respone.data', respone)
            self.view.CountDown.active = false;
            //验证码
            LoaclStorage.setNumber("BIND_CODE_TIME", Date.parse(new Date().toString()))
            self.view.onClickInvitation(60);
            invitationCountdownManager.instance.startCounting();
            let dataStr = LoaclStorage.getString("SET_BANK_DATA")
            if (dataStr != null){
                let data = JSON.parse(dataStr)
                data.PhoneNumber = mobilePhoneNumber
                data.PhoneHead = self.areaCode
                LoaclStorage.setString("SET_BANK_DATA", JSON.stringify(data))
            }
        },(error)=>{

            if (self.loginScene && error.code == "B00046") {
                
                let responseData = {msg:LanguageManager.t("login_unbinding_cellphone")};
                ModuleManager.instance.toast500error(responseData);
            }else{
             
                ModuleManager.instance.toast500error(error);
            }
            
        })
    }
    checkAreaCode(code:string)
    {
        let result =  this.areaCodeArray.find(data=>{return data == code});
        cc.log("检测白名单的区域号:",result,this.areaCodeArray);
        if(result)
        {
            return true;
        }
        else{
            return false;
        }
    }
}
